<template>
  <div class="app-bank-account">
    <SimonModal
      :is-visible="showSEPAInfoModal"
      @hide="showSEPAInfoModal = false"
      id="sepa-info-modal"
    >
      <slot name="txtSEAPInfo"></slot>
    </SimonModal>
    <b-form-group class="account-holder-group pr-0">
      <label for="accountHolder"><slot name="lblAccountHolder">Kontoinhaber</slot></label>
      <b-form-input
        name="accountHolder"
        id="accountHolder"
        type="text"
        v-model="owner_"
        :disabled="true"
        :formatter="formatterCharFilterOnlyAplha"
        @input="$v.owner_.$touch"
        @focus="vflowInputFocused('owner_'); onFieldFocus()"
        @blur="vflowInputBlurred('owner_');"
      >
      </b-form-input>
      <b-form-invalid-feedback>
        <slot name="txtInvalidAccountHolder"></slot>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group class="iban-group mandatory" :class="vflowGetFeedbackClasses('iban_')">
      <label for="iban"><slot name="lblIBAN">IBAN</slot></label>
      <b-form-input
        ref="inputIBAN"
        name="iban"
        id="iban"
        type="text"
        v-model="iban_"
        required
        @input="formatIBAN"
        @focus="vflowInputFocused('iban_'); onFieldFocus()"
        @blur="vflowInputBlurred('iban_');"
      >
      </b-form-input>
      <b-form-invalid-feedback>
        <slot name="txtInvalidIBAN"></slot>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group class="payment-confirmation-group mandatory checkbox-group"  :class="vflowGetFeedbackClasses('confirmation_', 'checked')">
      <b-form-checkbox :class="['mt-0']"
                       v-model.trim="confirmation_"
                       required
                       id="sepamandate"
                       @input="$v.confirmation_.$touch; vflowInputFocused('confirmation_');"
                       @click="$v.confirmation_.$touch; vflowInputFocused('confirmation_'); onFieldFocus()"
                       @change="$v.confirmation_.$touch; vflowInputFocused('confirmation_');"
      >
        <span><slot name="lblConfirmationPre"></slot> <a href="javascript:;" @click="showSEPAInfoModal = true"><slot name="lblConfirmation">SEPA erlauben</slot></a><slot name="lblConfirmationPost"></slot></span>
        <b-form-invalid-feedback>
          <slot name="txtConfirmationRequired">Dies ist ein Pflichtfeld.</slot>
        </b-form-invalid-feedback>
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import { maxLength, required } from 'vuelidate/lib/validators'
import syncProperty from '@/mixins/syncProperty'
import validationFlow from '@/mixins/validators/validationFlow'
import inputFormatter from '@/mixins/formatters/inputFormatter'
import ibanValidator from '@/mixins/validators/ibanValidator'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'PaymentBankAccount',
  components: { SimonModal },
  data () {
    return {
      confirmation_: false,
      showSEPAInfoModal: false,
      brandConsents: {
        consents: [{
          text: ''
        }
        ]
      },
      brand: ''
    }
  },
  mounted () {
    this.formatIBAN(this.iban_)
    this.$v.$touch()
    this.invalid_ = this.$v.$invalid
  },
  watch: {
    '$v.$invalid': function (newValue) {
      this.invalid_ = newValue
      this.$emit('update:invalid', newValue)
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('iban', 'iban_'),
    syncProperty('owner', 'owner_'),
    syncProperty('invalid', 'invalid_'),
    validationFlow,
    inputFormatter,
    ibanValidator
  ],
  methods: {
    setCursorPosition (el, pos) {
      el.focus()
      el.setSelectionRange(pos, pos)
    },
    ibanFormatted (v) {
      let r = v

      if (v !== null) {
        let iban = v.toUpperCase().replace(/[^\dA-Z]/g, '')
        if (iban.length > 34) {
          iban = iban.substr(0, 34)
        }
        r = iban.replace(/(.{4})/g, '$1 ').trim()
      } else {
        r = ''
      }

      return r
    },
    onFieldFocus () {
      this.$emit('focused')
    },
    formatIBAN (pv) {
      const v = (typeof pv !== 'undefined') ? pv : this.iban_
      // handle value-edit event
      if (this.$refs.inputIBAN.selectionStart < v.length) {
        const startPos = this.$refs.inputIBAN.selectionStart
        this.$refs.inputIBAN.localValue = this.ibanFormatted(v)
        this.iban_ = this.ibanFormatted(v)
        this.$v.iban_.$touch()
        this.$nextTick(() => this.setCursorPosition(this.$refs.inputIBAN, startPos))
        return
      }
      this.$refs.inputIBAN.localValue = this.ibanFormatted(v)
      this.iban_ = this.ibanFormatted(v)
      this.$v.iban_.$touch()
    },
    formValidation () {
      this.$v.$touch()
      this.invalid_ = this.$v.$invalid
      if (this.invalid_) {
        this.vflowForceFeedback()
      }
    }
  },
  props: {
    isPUC: {
      type: Boolean
    },
    filterKeys: {
      type: String,
      default: 'privilege_terms'
    }
  },
  validations () {
    return {
      confirmation_: {
        checked (v) {
          return (true && v)
        }
      },
      owner_: {
        maxLength: maxLength(50)
      },
      iban_: {
        required,
        found (v) {
          return this.validateIBAN(v)
        }
      }
    }
  },
  apollo: {
    brandConsents: function () {
      const query = wrapQuery(gql`query prevTerms ($brand: String!, $filterKeys: [String!]) {
        brandConsents(brand:$brand, filterKeys: $filterKeys) {
          consents {
            text
          }
        }
      }`, this, 'brandConsents', {
        brand: this.$store.getters.brand,
        filterKeys: this.filterKeys
      })
      return query
    }
  }
}
</script>
